import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

let serverUrl = appConfig.server_url


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_USER(state, users) {
    state.cached = users
  },
}

export const actions = {

  init({ state, dispatch }) {},


  fetchUsers(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/base/users/${query}`).then((response) => {
      const users = response.data
      context.commit('CACHE_USER', users)
      return users
    })
  },
  
  fetchUsersForOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/base/users/for_options/${query}`).then((response) => {
      return response.data
    })
  },
  
  fetchUsersDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateUsers(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formData.url, formData)
    }else {
      promise =  axios.post(`${serverUrl}/base/users/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  deleteUsers(context, url) {
    let promise = null
    promise =  axios.delete(url)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  changePassword(context, formData) {
    let promise = null
    promise =  axios.put(`${formData.url}set_password/`, formData)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  updatePhotos(context, formData) {
      let promise = null
      promise =  axios.put(`${formData.get('url')}set_photo/`, formData, {
        headers: {'Content-Type': 'multipart/form-data'}
      })
      return promise.then(
        (response) => {
          return response.data
        }
      )
    },
}